import { DataCache } from '../components/data-driven-logo/data-cache';

export const getCachedNormalizedBYOLProviders = () =>
  DataCache.getCachedProviders().reduce((BYOLProviders, p) => {
    if (!p.bringYourOwnLabelCapable) {
      return BYOLProviders;
    }
    return {
      ...BYOLProviders,
      [p.providerId.toString()]: p,
    };
  }, {});

export const useNormalizedBYOLProviders = () => {
  return getCachedNormalizedBYOLProviders();
};
